import type { ElementState, ScenarioState, singleElementState } from "@/types";

import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";

const elementSate: ElementState<any> = {
  data: [],
  error: null,
  loading: false,
};

const singleElementSate: singleElementState<any> = {
  data: [],
  error: null,
  loading: false,
};

export const scenarioState: ScenarioState = {
  scenarios: elementSate,
  scenario: singleElementSate,
  scenariosByIDList: elementSate,
};

export const ScenarioModule = {
  namespaced: true,
  state: scenarioState,
  actions,
  mutations,
  getters,
};
